"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ModalCss_1 = require("./ModalCss");
var _1 = require(".");
var CryptoJS = __importStar(require("crypto-js"));
function DetectorModal(props) {
    var reloadPage = function (event) {
        event.preventDefault();
        window.location.reload();
    };
    var sessionKey = CryptoJS.SHA256((new Date().toDateString())).toString();
    var styles = (0, ModalCss_1.generateStyles)({
        theme: props.theme,
        sessionKey: sessionKey
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("style", null, styles),
        react_1.default.createElement("div", { className: (0, _1.decode_class)('modal', sessionKey) },
            react_1.default.createElement("div", { className: "".concat((0, _1.decode_class)('content', sessionKey), " fadeInDown") },
                react_1.default.createElement("div", { className: (0, _1.decode_class)('body', sessionKey) },
                    react_1.default.createElement("div", { className: (0, _1.decode_class)('theme', sessionKey) },
                        react_1.default.createElement("div", { className: (0, _1.decode_class)('body', sessionKey) },
                            (props === null || props === void 0 ? void 0 : props.closeBtn) && react_1.default.createElement("button", { onClick: props.onModalClose, className: (0, _1.decode_class)('closebtn', sessionKey), type: "button" }),
                            react_1.default.createElement("div", { className: (0, _1.decode_class)('newtheme_container_content', sessionKey) },
                                react_1.default.createElement("div", { className: "wrapper" },
                                    react_1.default.createElement("div", { className: "adblock_new_icon" },
                                        react_1.default.createElement("div", { className: "image-container" },
                                            react_1.default.createElement("div", { className: "image" },
                                                react_1.default.createElement("i", { className: "exclametry_icon" }, "!"),
                                                react_1.default.createElement("h3", null, "Ads"))))),
                                react_1.default.createElement("div", { className: (0, _1.decode_class)('main_content', sessionKey) },
                                    react_1.default.createElement("h4", { className: (0, _1.decode_class)('adblock_title', sessionKey) }, props.title),
                                    react_1.default.createElement("div", { className: (0, _1.decode_class)('adblock_subtitle', sessionKey) }, props.message)))),
                        react_1.default.createElement("div", { className: (0, _1.decode_class)('footer', sessionKey) },
                            react_1.default.createElement("button", { className: "action-btn-ok adblock_btn", onClick: reloadPage }, props.reloadBtnText))))))));
}
exports.default = DetectorModal;
DetectorModal.defaultProps = {
    show: false,
    title: "Adblock Detected!!!",
    message: "We have detected that you are using extensions to block ads. Please support us by disabling these ads blocker.",
    reloadBtnText: "I've Disable Adblock",
    closeBtn: false,
    onModalClose: function () { },
    theme: "#ff0000"
};
//# sourceMappingURL=DetectorModal.js.map